import React from "react";
import { formatMoney } from "banco/util/formatter";

interface RepresentativeExampleFooterProps {
  loan_calc_constants: {
    representative_example_amount: number | string;
    representative_example_months: number | string;
    representative_example_nominal_rate: number | string;
    representative_example_apr: number | string;
    representative_example_total_to_repay: number | string;
    representative_example_interest_amount: number | string;
    representative_example_regular_repayment_amount: number | string;
    representative_example_final_repayment_amount: number | string;
  };
  display_direct_booking_rep_apr_note?: boolean;
  trading_name?: string;
  tdClassName?: string;
}

export const RepresentativeExampleFooter: React.FC<RepresentativeExampleFooterProps> = ({
  loan_calc_constants,
  display_direct_booking_rep_apr_note,
  trading_name,
  tdClassName,
}) => {
  const no_dec_money = (val?: number | string) => formatMoney(val, "$0,0", true);

  return (
    <>
      <tr>
        <td colSpan={ 4 } className={ tdClassName }>
          <span data-fb-panel="rep-example">
            On an assumed loan amount of
            { ` ${no_dec_money(loan_calc_constants.representative_example_amount)}` } over
            { ` ${loan_calc_constants.representative_example_months}` } months.
            Rate of interest
            { ` ${Number(loan_calc_constants.representative_example_nominal_rate)}% ` }
            per annum (fixed).
          </span>
          <span data-fb-panel="rep-apr">
            { ` Representative ${loan_calc_constants.representative_example_apr}% APR. ` }
          </span>
          <span data-fb-panel="total-payable">
            Total amount payable
            { ` £${loan_calc_constants.representative_example_total_to_repay} ` }
            { " " }of
            which { ` £${loan_calc_constants.representative_example_interest_amount} ` }
            is interest.
          </span>
          { " " }
          <span data-fb-panel="monthly-repayments">
            { Number(loan_calc_constants.representative_example_months) - 1 } monthly repayments of
            { ` £${loan_calc_constants.representative_example_regular_repayment_amount} ` }
            and a final payment of
            { ` £${loan_calc_constants.representative_example_final_repayment_amount}` }.
          </span>
        </td>
      </tr>
      { display_direct_booking_rep_apr_note && (
        <tr>
          <td colSpan={ 4 } className={ `direct-customers-note ${tdClassName || ""}`.trim() }>
            Only for customers booking directly on our { trading_name } website.
          </td>
        </tr>
      ) }
    </>
  );
};
